import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth()
  const location = useLocation()
  if (loading) {
    return <div className="flex h-full items-center justify-center text-slate-500">Loading…</div>
  }
  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  return <>{children}</>
}
